import { MenuItem, Typography, Stack, Tooltip, Checkbox } from '@mui/material';

import React from 'react';

import { ListChildComponentProps } from 'react-window';

import styles from './AdvancedFilters.module.scss';

export interface IAdvancedFilterListItemOptions {
	label: any;
	value: string;
	checked?: boolean;
	type?: string;
	disabled?: boolean;
}
const { checkboxCheckedColor, checkboxUncheckedColor } = styles;
const AdvancedFilterListItems = ({
	index,
	style,
	data,
	handleOptionChange,
	selectedOptionsLabels,
	selectedOptionsLabelTypes,
}: ListChildComponentProps<any[]> & {
	handleOptionChange: (
		option: IAdvancedFilterListItemOptions,
		event: any,
	) => void;
} & {
	selectedOptionsLabels: string[];
	selectedOptionsLabelTypes: string[];
}) => {
	const item = data[index];

	const renderCheckBox = (label: any, iele: IAdvancedFilterListItemOptions) => (
		<Checkbox
			size="small"
			sx={{
				color: checkboxUncheckedColor,
				'&.Mui-checked': {
					color: checkboxCheckedColor,
				},
			}}
			disabled={iele?.disabled}
			checked={
				selectedOptionsLabels.includes(label) &&
				selectedOptionsLabelTypes.includes(iele?.type ?? '')
			}
			onChange={(event) => handleOptionChange(iele, event)}
			data-testid="advancefilters-checkbox"
		/>
	);

	const label =
		typeof item?.label === 'object' ? item?.label?.value : item?.label;
	return (
		<Stack key={item?.id} style={style}>
			<MenuItem
				disableRipple
				key={label}
				value={label}
				className={styles['advancedfilters-accordion-maincontent']}
				data-testid="advancefilters-listitem"
			>
				<Stack
					direction="row"
					alignItems="center"
					justifyContent="space-between"
					width="100%"
					className={styles['advancedfilters-accordion-maincontent-stack']}
				>
					<Stack direction="row" alignItems="center">
						{renderCheckBox(label, item)}

						<Tooltip
							title={label}
							placement="bottom"
							componentsProps={{
								popper: {
									sx: { zIndex: '10001 !important' },
								},
							}}
						>
							<Typography
								className={styles['advancedfilters-accordion-content']}
							>
								{label}
							</Typography>
						</Tooltip>
					</Stack>
					<Typography className={styles['advancedfilters-accordion-count']}>
						{item?.label?.count}
					</Typography>
				</Stack>
			</MenuItem>
		</Stack>
	);
};

export default AdvancedFilterListItems;
